<template>
  <v-row class="cont">
    <v-icon clr="var(--v-gray2-base)" style="width: 73px;height: 73px;"
      >$checkIcon</v-icon
    >
    <p class="mt-4 font-Regular-24">
      {{ $t("staking.statusPage.Plan_Activated") }}
    </p>
    <div class="timeline mt-4">
      <div
        v-for="(item, i) in items"
        :key="i"
        class="timeline-item"
        :class="{ active: i === 0 }"
      >
        <div class="circle"></div>
        <div class="label font-Regular-16 onPrimary--text">
          <span class="font-Medium-16">{{ item.label }}</span>
          <div class="mt-2 font-Light-14 gray2--text">
            <span class="ltr">
              {{ $t("common.Date") }}
              {{ item.date | formatDate }}</span
            >
            <!--            <span>-->
            <!--              {{ $t("common.Time") }}-->
            <!--              {{ formatTimes(item.date) }}</span-->
            <!--            >-->
          </div>
        </div>
      </div>
    </div>
    <v-col>
      <v-btn
        text
        block
        class="py-6 primary font-Medium-14"
        href="/panel/staking?tab=MY_PLANS"
        >{{ $t("staking.statusPage.View_My_Plans") }}</v-btn
      >
    </v-col>

    <v-btn
      block
      text
      class="py-6 mt-4 primary--text font-Medium-14"
      href="/panel/staking?tab=ALL_PLANS"
      >{{ $t("staking.statusPage.Plans_List") }}</v-btn
    >
  </v-row>
</template>

<script>
import dayjs from "dayjs";

export default {
  name: "stakingStatus",
  props: ["data"],
  data() {
    return {};
  },
  methods: {
    formatTimes(time) {
      return dayjs(time).format("mm : HH");
    }
  },
  computed: {
    items() {
      return [
        {
          label: this.$t(
            "staking.stakingPlans.dialogDetail.planSchedule.Start_Of_Staking_Plan"
          ),
          date: this.data.subscriptionStartDate
        },
        {
          label: this.$t(
            "staking.stakingPlans.dialogDetail.planSchedule.Daily_Profit_Distribution_Date"
          ),
          date: this.data.profitDistributionDate
        },
        {
          label: this.$t(
            "staking.stakingPlans.dialogDetail.planSchedule.Plan_End_Date"
          ),
          date: this.data.subscriptionEndDate
        },
        {
          label: this.$t(
            "staking.stakingPlans.dialogDetail.planSchedule.Profit_Release_Date"
          ),
          date: this.data.profitReleaseDate
        },
        {
          label: this.$t(
            "staking.stakingPlans.dialogDetail.planSchedule.Asset_Release_Date"
          ),
          date: this.data.assetReleaseDate
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.cont {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 60px;
}
.timeline {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  margin: 0px 0px 40px 0px;
}

.timeline-item {
  position: relative;
  padding-bottom: 8px;
}
.ltr .timeline-item::before {
  left: 5.5px;
}
.timeline-item::before {
  content: "";
  position: absolute;
  right: 5.5px;
  top: 20px;
  width: 2px;
  height: 100%;
  background-color: #888; /* رنگ خط پیش‌فرض */
  z-index: 0;
}

/* آخرین آیتم خط پایین نداشته باشه */
.timeline-item:last-child::before {
  display: none;
}

.timeline-item.active::before {
  background-color: #3f51b5; /* رنگ خط فعال */
}

.circle {
  width: 12px;
  height: 12px;
  background-color: #888;
  border-radius: 50%;
  position: absolute;
  top: 10px;
  z-index: 1;
}

.timeline-item.active .circle {
  background-color: #3f51b5; /* دایره فعال */
}
.ltr .label {
  margin-left: 20px;
}
.label {
  margin-right: 20px;
  margin-top: 10px;
  display: block;
}
</style>
